export enum PaymentExpectationStatus {
  PENDING = "PENDING",
  PARTIALLY_RECEIVED = "PARTIALLY_RECEIVED",
  OVERDUE = "OVERDUE",
  RECEIVED = "RECEIVED",
  CANCELLED = "CANCELLED",
}

export enum PaymentExpectationSourceType {
  INVOICE = "INVOICE",
  ADVANCE = "ADVANCE",
  AMC = "AMC",
  OTHER = "OTHER",
}

export enum PaymentExpectationDirection {
  IN = "IN",
  OUT = "OUT",
}

export const paymentExpectationStatusMap: Record<
  PaymentExpectationStatus,
  { label: string; color: string }
> = {
  [PaymentExpectationStatus.PENDING]: { label: "Pending", color: "secondary" },
  [PaymentExpectationStatus.PARTIALLY_RECEIVED]: {
    label: "Partial",
    color: "warning",
  },
  [PaymentExpectationStatus.OVERDUE]: { label: "Overdue", color: "danger" },
  [PaymentExpectationStatus.RECEIVED]: { label: "Received", color: "success" },
  [PaymentExpectationStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
};

export const paymentExpectationSourceTypeLabelMap: Record<
  PaymentExpectationSourceType,
  string
> = {
  [PaymentExpectationSourceType.INVOICE]: "Invoice",
  [PaymentExpectationSourceType.ADVANCE]: "Advance",
  [PaymentExpectationSourceType.AMC]: "AMC",
  [PaymentExpectationSourceType.OTHER]: "Other",
};

export const paymentExpectationSourceTypeOptions = Object.values(
  PaymentExpectationSourceType,
).map((v) => ({
  value: v,
  label: paymentExpectationSourceTypeLabelMap[v],
}));

/** Statuses where the expectation is locked — no edits or receipt recording allowed. */
export function isTerminalPaymentExpectationStatus(
  status: string | null | undefined,
): boolean {
  return (
    status === PaymentExpectationStatus.RECEIVED ||
    status === PaymentExpectationStatus.CANCELLED
  );
}
